//Serviços
import { Axios } from "../../service/serviceBasic";
import { toast } from "react-toastify";
import { setMessageConclusaoAction } from "../conclusao/actions";

//Tipos
import {
  SET_LOADING_PAGE,
  SET_DOCUMENTOS_SOLICITADOS,
  SET_TIPOS_DOCUMENTO_SOLICITADOS,
  SET_ACCEPT_IMAGE
} from "./types";
import { findLastIndex } from "lodash";

const setLoadingPage = (flag) => ({
  type: SET_LOADING_PAGE,
  payload: flag,
});

const setSolicitacoes = (object) => ({
  type: SET_DOCUMENTOS_SOLICITADOS,
  payload: object,
});

const setTiposDocumentoSolicitados = (list) => ({
  type: SET_TIPOS_DOCUMENTO_SOLICITADOS,
  payload: list,
});

const setAcceptImage = (list) => ({
  type: SET_ACCEPT_IMAGE,
  payload: list,
});

export const listDocumentosSolicitadosAction = (idSolicitacao, history) => dispatch => {

  dispatch(setLoadingPage(true));

  return Axios.post("/v1/cliente/tipodocumento/listByProcam", null)
  .then(result => {

    Axios.post("/v1/cliente/tipoarquivo/list", null)
    .then(res => {
      if(res !== null && res.data.length > 0) {
        const accept = acceptImage(res.data);
        dispatch(setAcceptImage(accept));
      }
    })
    .catch(() => {});
    
    return Axios.post("/v1/cliente/solicitacao/listBySolicitacao", {idSolicitacao})
    .then(res => {
      const solicitacoesNaoAtendidas = res.data.filter(x => x.DataHoraAtendida === null);

      if (solicitacoesNaoAtendidas === null || solicitacoesNaoAtendidas.length === 0) {
        dispatch(
          setMessageConclusaoAction({
            icon: "fa-check-circle-o",
            title: "Os documentos solicitados já foram enviados!",
            email: "",
            discription:"",
            isError: false,
          })
        );
        history.push("/conclusao");
      } else {
        let tiposDocSolicitados = [];
      
        result.data.map(x => {
          if (solicitacoesNaoAtendidas.some(y => y.IdTipoDocumento === x.IdTipoDocumento)) {
            tiposDocSolicitados.push(x);
          }
          return x;
        })
        dispatch(setTiposDocumentoSolicitados(tiposDocSolicitados));
        dispatch(setSolicitacoes(solicitacoesNaoAtendidas));
      }
    })
    .catch((error) => {
      const errorMsg = error && error.response && error.response.data &&
      error.response.data.Message ? error.response.data.Message : "Ocorreu um erro. Tente novamente mais tarde.";
      
      toast.warn(errorMsg, {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "ui-alert-toast",
        bodyClassName: "ui-alert-toast-content",
      });
      history.push("/");
    })  
  })
  .catch((error) => {
    const errorMsg = error && error.response && error.response.data &&
    error.response.data.Message ? error.response.data.Message : "Ocorreu um erro. Tente novamente mais tarde.";
    
    toast.warn(errorMsg, {
      position: toast.POSITION.BOTTOM_RIGHT,
      className: "ui-alert-toast",
      bodyClassName: "ui-alert-toast-content",
    });
    history.push("/");
  })
  .finally(() => {
    dispatch(setLoadingPage(false));
  });  
}

export const enviarArquivos = (files, history) => dispatch => {

  dispatch(setLoadingPage(true));
  return Axios.post("/v1/cliente/documentoImagem/salvarDocumentosSolicitados", files)
  .then(res => {
    dispatch(
      setMessageConclusaoAction({
        icon: "fa-check-circle-o",
        title: "Documentos enviados com sucesso!",
        email: "",
        discription:"",
        isError: false,
      })
    );
    history.push("/conclusao");
  })
  .catch(error => {
    const errorMsg = error && error.response && error.response.data &&
    error.response.data.Message ? error.response.data.Message : "Ocorreu um erro. Tente novamente mais tarde.";
    
    if (errorMsg.includes("Documento solicitado não enviado")) {
      dispatch(listDocumentosSolicitadosAction(files[0].IdSolicitacao, history));
    }

    toast.warn(errorMsg, {
      position: toast.POSITION.BOTTOM_RIGHT,
      className: "ui-alert-toast",
      bodyClassName: "ui-alert-toast-content",
    });

  })
  .finally(() => {
    dispatch(setLoadingPage(false));
  }) 
}

const acceptImage = (list) => {
  var result = "";
  list.map((item, index) => {
    result += "." + item.Nome;
    if (findLastIndex(list) > index) {
      result += ",";
    }
    return item;
  })

  return result;
}
